import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoggedIn } from '../../../../features/account/account.slice';

const DeleteDeviceDetails = ({ device, deviceData, onClose, setDeviceData, setServerMessage }) => {

    const [disableButtons, setDisableButtons] = useState(false);

    const deviceModel = device === "A" ? deviceData.devices[0]?.deviceModel : deviceData.devices[1]?.deviceModel;

    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const dispatch = useDispatch();

    const removeDevice = async (updatedDevices) => {
        try {
            const response = await fetch(`${apiUrl}/subscription/remove-device`, {
                method: 'PUT',
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updatedDevices }) // Send the updated devices array
            });

            if (response.status === 401) {
                // Unauthorized, possibly session expired
                dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
                return;
            };

            const data = await response.json();

            if (data.success) {
                setServerMessage(data);
                onClose();
                // Update local device data state
                const updatedData = deviceData;
                updatedData.devices = updatedDevices;
                setDeviceData(updatedData);
            } else {
                setServerMessage(data);
            }
        } catch (error) {
            console.error('Error removing device:', error);
            setServerMessage({ success: false, message: 'An error occurred while removing the device.' });
        }
    };

    const handleDelete = async () => {
        setDisableButtons(true);
        let updatedDevices = [];
        if (device === "A") {
            // Remove first device
            updatedDevices = deviceData.devices.slice(1);
        } else if (device === "B") {
            // Remove second device
            updatedDevices = [deviceData.devices[0]];
        }
        
        await removeDevice(updatedDevices);
    }

    return (
        <div className='m-4 text-center'>
            <h4>Delete Device</h4>
            <div className='d-flex flex-column gap-3 mb-2'>
                <p>Are you sure you want to delete your <span style={{fontWeight: "bold"}}>{deviceModel}</span> device?</p>
                <p>
                    Please note that deleting a device will free up a slot to add a new device. However, the total number of devices you can add over time is limited to three per subscription. 
                    If you delete this device and add a new one, it will count towards your total limit of three devices. Once you reach this limit, you will no longer be able to add or remove devices.
                </p>
                <p>
                    Make sure to keep at least one device available at your primary location to ensure uninterrupted access to your account.
                </p>
                <p>This action cannot be undone.</p>
                <div className='d-flex justify-content-center mt-3'>
                    <button className='btn btn-secondary me-3' style={{width: "100px"}} onClick={onClose} disabled={disableButtons}>Cancel</button>
                    <button className='btn btn-danger' style={{width: "100px"}} onClick={() => handleDelete()} disabled={disableButtons}>Delete</button>
                </div>
            </div>
        </div>
    )
}

export default DeleteDeviceDetails